export default "__VITE_ASSET__ce2cac79__"